module.exports = __webpack_public_path__ + "static/media/front.761569af.svg";